import React from 'react'

const Link = (props) => {
  const { url } = props.contentState.getEntity(props.entityKey).getData()
  return (
    <a
      href={url}
      style={{
        color: '#5890ff',
        textDecoration: 'underline',
      }}
      target="_blank"
      rel="noreferrer"
    >
      {props.children}
    </a>
  )
}

export default Link



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RichEditor/Link.js